export default __webpack_public_path__ + "static/media/need-you.3da6eab7.png";